import styled from "@emotion/styled";

export const StyledBody = styled("div")(({ bannerHeight, bgColor }) => ({
  marginLeft: "20vh",
  marginRight: "20vh",
  paddingTop: bannerHeight,
  backgroundColor: bgColor,
}));
